"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBCollateralLocationNegative = function SvgBCollateralLocationNegative(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M98.341 143.677h-9.974a2.107 2.107 0 01-2.107-2.107v-33.233c0-1.164.943-2.107 2.107-2.107h10.635a.499.499 0 00.491-.33.485.485 0 00-.119-.576L50.126 56.069C38.634 45.11 32.228 31.996 32.228 19.184a2.725 2.725 0 010-.338C32.727 5.893 42.743 0 51.875 0c9.132 0 19.142 5.893 19.612 18.825.007.113.007.225 0 .338 0 9.707-3.182 19.127-9.462 27.999l-1.812 2.613a2.107 2.107 0 11-3.463-2.395l1.82-2.635c5.773-8.092 8.696-16.647 8.73-25.4v-.253c-.336-10.22-8.225-14.877-15.425-14.877-7.2 0-15.088 4.657-15.404 14.877v.253c.056 11.597 5.956 23.56 16.626 33.717l49.29 49.29a4.748 4.748 0 01-3.357 8.107h-8.556v29.017h7.867a2.107 2.107 0 010 4.215v-.014z"
  }), (0, _core.jsx)("path", {
    d: "M51.89 26.566a7.727 7.727 0 115.555-2.332 7.727 7.727 0 01-5.577 2.332h.021zm0-11.288a3.554 3.554 0 00-3.358 4.713 3.512 3.512 0 003.35 2.36c.95.002 1.86-.38 2.522-1.06a3.547 3.547 0 001.004-2.564 3.596 3.596 0 00-3.385-3.442l-.134-.007zM15.383 143.677H5.381a2.107 2.107 0 110-4.215h7.895v-29.018H4.748a4.748 4.748 0 01-3.343-8.106L43.46 60.276a2.107 2.107 0 012.978 2.979L4.376 105.317a.534.534 0 00.372.913h10.635c1.164 0 2.108.943 2.108 2.107v33.233a2.107 2.107 0 01-2.108 2.107z"
  }), (0, _core.jsx)("path", {
    d: "M78.47 143.677H61.814a2.107 2.107 0 01-2.108-2.107v-31.111H44.015v31.11a2.107 2.107 0 01-2.107 2.108H9.238a2.107 2.107 0 110-4.215H39.8v-31.11c0-1.165.944-2.108 2.108-2.108h19.907c1.163 0 2.107.943 2.107 2.107v31.111h14.554a2.107 2.107 0 110 4.215h-.007z"
  })));
};

var _default = SvgBCollateralLocationNegative;
exports["default"] = _default;